import React from "react";
import { NavLink, useMatch } from "react-router-dom";
import arrow from "../../../../assets/images/icons/chevron-right.svg";
import { useTranslation } from "react-i18next";

interface TitleNavLinkOfPatientProfileProps {
  to: string;
  label: string;
}

const TitleNavLinkOfPatientProfile: React.FC<
  TitleNavLinkOfPatientProfileProps
> = ({ to, label }) => {
  const match = useMatch({
    path: to,
    end: true,
  });
  const isActive = !!match;

  const { t } = useTranslation();

  const handleClick = () => {
    if (window.innerWidth <= 1024) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <NavLink
      to={to}
      onClick={(e) => {
        window.scrollTo(0, 0);
        handleClick();
      }}
      className={`hover:bg-primary-click text-primary-textFont flex items-center justify-between rounded-lg border px-4 py-3 transition-all hover:border hover:border-primary hover:font-bold ${isActive ? "bg-primary-click border-primary font-bold" : "border-white"} overflow-hidden`}
    >
      <span>{t(label)}</span>
      <img src={arrow} alt="arrow" className={`h-5 w-5 rtl:-scale-100`} />
    </NavLink>
  );
};

export default TitleNavLinkOfPatientProfile;
